// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Saira:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	/*font-family: "Outfit", sans-serif!important;*/
	font-family: "Roboto", sans-serif !important;
	font-size: 15px !important;
}

.mt-7 {
	margin-top: 0;
}


.App {
	text-align: center;
}

.App-logo {
	height: 40vmin;
	pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
	.App-logo {
		animation: App-logo-spin infinite 20s linear;
	}
}

.App-header {
	background-color: #282c34;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-size: calc(10px + 2vmin);
	color: white;
}

.App-link {
	color: #61dafb;
}

@keyframes App-logo-spin {
	from {
		transform: rotate(0deg);
	}

	to {
		transform: rotate(360deg);
	}
}


.mainmenu {
	border-top: 1px solid #d5d8e2 !important;
	padding: 0 !important;
	margin: 0 !important;
	height: inherit !important;
	min-height: inherit !important;
	align-items: inherit !important;
}

.mainmenu button {
	font-family: "Outfit", sans-serif;
	font-size: 15px;
	color: #000;
	border-radius: 0;
	padding-top: 10px;
	padding-bottom: 10px;
}

.mainmenu button:hover {
	background-color: #b32a7f;
	color: #fff;
	border-radius: 0;
}

.mainmenu button.active {
	background-color: #b32a7f;
	color: #fff;
}


.sub-nav .MuiTabs-flexContainer {
	text-align: center;
	border-bottom: 1px solid #ccc;
	justify-content: center;
}

.schedule-one__single {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	background-color: rgba(0, 0, 0, .08);
	border-radius: 20px;
	padding: 30px 40px 30px;
	margin-bottom: 30px;
	z-index: 1;
}

.schedule-one__left {
	position: relative;
	display: block;
}

.top-brand {
	padding: 16px 0px !important;
}



.schedule-one__img {
	position: relative;
	display: block;
	max-width: 309px;
	width: 100%;
	border-radius: 20px;
	overflow: hidden;
	z-index: 1;
}

.schedule-one__img::after {
	background: hsla(0, 0%, 100%, 0.5);
	content: "";
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 0;
	opacity: 1;
	z-index: 9;
	pointer-events: none;
}

.schedule-one__img img {
	width: 100%;
	border-radius: 20px;
	object-fit: cover;
	transition: all 1s ease-in-out;
}

.event-list table {}

.event-list table th {
	background-color: #333;
	font-family: "Outfit", sans-serif !important;
	font-size: 14px;
	color: #ffffff;
}

.event-list table td img {
	width: 35px;
	height: 35px;
	border: 1px solid #ccc;
	padding: 2px;
}

.event-list table {
	border-radius: 10px !important;
	overflow: hidden;
	font-family: "Outfit", sans-serif !important;
	background-color: #fff;
}

.event-list .MuiTableContainer-root {
	border: 1px solid #ccc;
	border-radius: 10px !important;

}


.event-list table tr:nth-child(2n) {
	background-color: #f8f6ff;
}

.event-list table td {
	font-family: "Outfit", sans-serif !important;
	font-size: 15px;
}

.event-list .active-btn svg:hover {
	opacity: .5;
}

.filter-panel {
	margin-bottom: 25px;
}

/*.serarch-bar .w-full {
	font-family: "Outfit", sans-serif !important;
	background: #f9f9fb !important;
	border: 1px solid #aeafc5 !important;
	padding: 4px 5px 0px !important;
	position: relative;
	font-size: 16px;
	display: block;
	width: 100%;
	color: #495057;
	border-radius: .25rem;
	transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
	height: auto !important;
}

.serarch-bar svg {
	width: 32px;
	background: #c942b1;
	fill: #fff;
	border-radius: 6px;
	height: 32px;
	padding: 5px;
	border: 0;
	margin-right: 10px;
}*/



.bg-primary {
	background: #b32a7f !important;
	font-family: "Outfit", sans-serif !important;
	font-size: 16px;
	color: #ffffff !important;
}

.bg-primary svg {
	color: #ffffff !important;
}


.event-data {
	background: #b32a7f;
	border-radius: 10px;
	text-align: center;
	align-content: center;
	padding: 31px 31px;
	color: #fff !important;
	height: 100%;
}

.event-data p {
	font-family: "Outfit", sans-serif !important;
	color: #fff !important;
	font-size: 18px;
}

.upcoming-events-list .MuiPaper-elevation {
	box-shadow: inherit !important;
	border: 1px solid #ccc !important;
	background-color: #fdfbfb;
	margin: 10px 0;
	height: auto !important;
}

.upcoming-events-list .MuiGrid-container {
	margin-left: 0 !important;
}

.upcoming-events-list h6 {
	font-family: "Outfit", sans-serif !important;
	color: #000;
	font-weight: 500;
	font-size: 18px;
	margin-bottom: 5px;
}

.upcoming-events-list p {
	font-family: "Outfit", sans-serif !important;
	color: #333;
	font-weight: 400;
	line-height: 26px;
	font-size: 16px;
}

.upcoming-events-list .row {
	width: 100% !important;
}

.upcoming-events-list select {
	background: #fff;
	border: 1px solid #ccc;
	padding: 7px 12px;
	border-radius: 5px;
	font-size: 14px;
	margin: 10px 0px 0px;
}

.text-primary {
	color: #b32a7f !important;
}

.text-primary:hover {
	color: #c942b1 !important;
}

.border-primary {
	border-color: #b32a7f !important;
}

.upcoming-events-list .MuiInputBase-formControl {
	width: 100% !important;
}

.upcoming-events-list .css-1nrlq1o-MuiFormControl-root {
	width: 180px !important;
}


/* ----*/

body {
	background-color: #ecf0fa !important;
}

.header-sec {
	background: #fff !important;
	border-bottom: 1px solid #d5d8e2 !important;
	border-top: 0 !important;
	z-index: 1 !important;
	margin-top: 0 !important;
	box-shadow: 0 1px 15px 1px #c0c0c7 !important;
}

.header-new {
	background: #c942b1 !important;
	border-bottom: 1px solid #d5d8e2 !important;
	border-top: 0 !important;
	/*z-index: 1 !important;*/
	margin-top: 0 !important;
	box-shadow: 0 1px 15px 1px #c0c0c7 !important;
}

.header-nav {
	border-bottom: 1px solid #d5d8e2 !important;
}

.nav-new {
	background-color: #fff !important;
}

.nav-new button {
	font-family: "Saira", sans-serif;
	font-weight: 500;
	letter-spacing: 0;
	font-size: 16px;
	color: #000 !important;
	cursor: pointer;
}

.nav-new button span {
	cursor: pointer;
}

.header-nav .MuiButtonBase-root {
	background: #cf55b9;
	border: 0 !important;
	padding: 1px !important;
	margin-right: 1px;
}

.header-nav .MuiButtonBase-root svg {
	fill: #fff !important;
}

.header-nav .MuiButtonBase-root:hover {
	background: transparent !important;
	box-shadow: inherit !important;
}

.sub-menu {
	font-family: "Saira", sans-serif !important;
	font-size: 15px;
	font-weight: 400 !important;
	width: 250px !important;
}

.sub-menu a {
	font-family: "Saira", sans-serif !important;
}

.profile-menu li {
	font-family: "Saira", sans-serif !important;
	font-size: 15px;
}


.pulse-wrapper {
	position: relative;
	display: inline-block;
	border: 1px solid #aa3796;
	border-radius: 50%;
	width: 41px;
	height: 41px;
}

.pulse-dot {
	/*position: absolute;
	top: 2px;
	right: -3px;
	width: 15px;
	height: 15px;
	border-radius: 50%;
	background: rgba(88, 11, 74, 0.6);
	box-shadow: 0 0 0 rgba(53, 2, 44, 0.9);
	pointer-events: none;
	animation: pulse 1s linear infinite;*/
}

@keyframes pulse {

	0%,
	8% {
		transform: scale(0);
		opacity: 0;
	}

	15%,
	30% {
		transform: scale(0.5);
		opacity: 1;
	}

	100% {
		transform: scale(1.1);
		opacity: 0;
	}
}

.breadcrumbs a {
	font-family: "Saira", sans-serif !important;
	font-size: 13px;
	font-weight: 400 !important;
}

.breadcrumbs span {
	font-family: "Saira", sans-serif !important;
	font-size: 13px;
	font-weight: 500 !important;
}



.card {
	position: relative;
	display: flex;
	flex-direction: column;
	min-width: 0;
	word-wrap: break-word;
	background: #fff !important;
	background-clip: border-box;
	border-radius: 6px !important;
	border: 0 !important;
	margin-bottom: 1.3rem;
	box-shadow: 6px 11px 41px -28px #796eb1;
	-webkit-box-shadow: 6px 11px 41px -28px #796eb1;
}


.card-body {
	flex: 1 1 auto;
	padding: 1.25rem;
	width: 100%;
}

.top-sec {
	width: 100%;
}

.main-content-label,
.card-body h3,
.card-body h4 {
	font-family: "Saira", sans-serif !important;
	color: #302e40;
	font-weight: 600;
	text-transform: uppercase;
	line-height: 1;
	margin-bottom: 10px;
	letter-spacing: .2px;
}

.top-sec button,
.top-sec a {
	box-shadow: inherit;
	font-family: "Saira", sans-serif !important;
	font-size: 14px;
	font-weight: 500;
}

.top-sec button:hover {
	box-shadow: inherit;
}

.site-bg {
	background: #cf55b9 !important;
	border-color: #cf55b9 !important;
}

.site-bg:hover {
	background: #a3278d !important;
}

.text-white{
	color: #fff !important;
}


.table-bordered thead th,
.table-bordered thead td {
	border-top-width: 1px;
	padding-top: 7px;
	padding-bottom: 7px;
	background-color: rgba(255, 255, 255, 0.5) !important;
}

.table thead th,
.table thead td {
	font-family: "Saira", sans-serif !important;
	color: #7987a1;
	font-weight: 500 !important;
	font-size: 14px;
	letter-spacing: .5px;
	text-transform: uppercase;
	border-bottom-width: 1px;
	border-top-width: 0;
	padding: 0 15px 5px;
}

.table thead th,
.table thead th strong {
	color: #000;
	font-weight: 500 !important;
}

.table thead th {
	padding-top: 8px;
	padding-bottom: 8px;
}

.table-striped tbody tr:nth-of-type(2n+1) {
	background-color: #f1f6fb !important;
}

.table-bordered td {
	font-family: "Saira", sans-serif !important;
	border: 1px solid #dedcfb !important;
	font-weight: 400 !important;
	padding-top: 5px !important;
	padding-bottom: 5px !important;
}

.table-bordered td img {
	width: 35px;
	height: 35px;
	border-radius: 50%;
}

.serarch-bar .border {
	border: 0 !important;
}

.serarch-bar {
	position: relative;
}

.serarch-bar input {
	font-family: "Saira", sans-serif !important;
	height: 37px;
	border-radius: 35px;
	background: #ecf0fa;
	border: 1px solid #ecf0fa;
	display: block;
	font-size: .875rem;
	font-weight: 400;
	line-height: 1.5;
	color: #4d5875;
	transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
	padding: 4px 60px 4px 20px;
}

.breadcrumbs svg {
	width: 15px !important;
}

.serarch-bar svg {
	position: absolute;
	right: 0;
	width: 78px !important;
}

.filter {
	font-family: "Saira", sans-serif !important;
	height: 40px;
	background: #ecf0fa;
	border: 1px solid #ecf0fa;
	display: block;
	font-size: 14px;
	font-weight: 400;
	line-height: 1.5;
	color: #4d5875;
	transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
	padding: 4px 60px 4px 20px;
}

.filter label {
	font-family: "Saira", sans-serif !important;
	font-size: 14px;
	line-height: 11px !important;
}

.MuiMenu-list li {
	font-family: "Saira", sans-serif !important;
}

.upcoming-event-list {
	background-color: #F8F9FA !important;
	border: 1px solid #F8F9FA !important;
	padding: 1rem !important;
	margin-bottom: 1rem !important;
	font-family: "Saira", sans-serif !important;
}

.upcoming-event-list img {
	height: 180px;
	width: 100%;
	object-fit: cover;
	border-radius: 8px;
	border: 1px solid #ccc;
}

.upcoming-event-list ul {
	list-style: none;
	padding: 0;
	margin: 0;
}

.upcoming-event-list ul li {
	display: inline-block;
	font-weight: 500;
	color: #000;
	margin-right: 15px;
}

.upcoming-event-list ul li:last-child {

	color: #a3278d;
	font-weight: 500;
}

.upcoming-event-list ul li {
	margin-bottom: 15px;
}

.upcoming-event-list ul li:last-child strong {
	font-weight: 400;
	color: #000;
}

.upcoming-event-list svg {
	width: 28px !important;
	display: inline-block;
	vertical-align: bottom;
}

.upcoming-event-list h2 {
	font-family: "Saira", sans-serif !important;
	font-size: 18px;
	font-weight: 500;
	margin: 20px 0px 5px;
	color: #000;
}

.upcoming-event-list {
	position: relative;
}

.upcoming-event-list select {
	background: #aa3796;
	font-family: "Saira", sans-serif !important;
	color: #fff;
	font-size: 14px;
	padding: 6px 17px;
	border-radius: 35px;
	position: absolute;
	right: 20px;
	bottom: 24px;
	-webkit-appearance: none;
	cursor: pointer;
}


.login-page {
	font-family: "Saira", sans-serif !important;
}

.market-le .row {
	width: 100%;
}

.product-card {
	border-radius: 10px !important;
	font-family: "Saira", sans-serif !important;
}

.product-card.card {
	box-shadow: inherit !important;
	border-radius: 11px !important;
	height: 100%;
	padding-bottom: 50px;
}

.product-card.card .border-gray-200 {
	border-color: transparent !important;
}

.product-card.card .\\!border {
	border: 0 !important;
}

.product-card.card button {
	box-shadow: inherit !important;
	border-radius: 0 !important;
	font-family: "Saira", sans-serif !important;
	font-size: 14px;
	padding: 8px 0px;
}


.ads-price {
	position: absolute;
	bottom: 0;
	z-index: 989999;
	background: #ff61e3;
	padding: 1px 14px;
	color: #fff;
	font-weight: 500;
	font-size: 17px;
	border-radius: 0px 6px 4px 0px;
}

.mrl-lising {
	padding-left: 25px;
	padding-right: 25px;
}

.market-filter .MuiSelect-select {
	padding-bottom: 0 !important;
}

.market-filter .filter label {
	line-height: 16px !important;
}

.product-card img {
	border-radius: 10px 10px 0px 0px !important;
}

.product-content {
	padding: 10px 15px;
	line-height: 30px;
}

.product-content span {
	color: #9939a9;
}

.product-content h2 {
	font-family: "Saira", sans-serif !important;
	font-size: 18px;
	color: #000;
	font-weight: 500;
}

.product-content p {
	font-family: "Saira", sans-serif !important;
	font-size: 15px;
	font-weight: 400;
	line-height: 26px;
}

.loading-msg {
	font-family: "Saira", sans-serif !important;
	font-size: 12px !important;
	font-weight: 400;
}

.image-show {
	position: relative;
}

.image-show::after {
	content: '';
	background: rgba(0, 0, 0, .3);
	display: inline-block;
	width: 100%;
	height: 100%;
	position: absolute;
	z-index: 999;
	top: 0;
	left: 0;
	border-radius: 10px;
}

.product-img {
	position: relative;
}

.add-status {
	position: absolute;
	top: 10px;
	right: 10px;
}


.ads-button {
	position: absolute;
	bottom: 0;
	width: 100%;
}

.ads-button .MuiBox-root {
	gap: 0 !important;
}


/* button */


.btn-icon {
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.btn-indigo {
	color: #fff;
	background-color: #b057bf;
	border-color: #b057bf;
}

.btn-indigo:hover {
	background-color: #9939a9;
	border-color: #9939a9;
}

.btn-denger {
	color: #fff;
	background-color: #f53c5b;
	border-color: #f53c5b;
}

.btn-denger:hover {
	color: #fff;
	background-color: #d72442;
	border-color: #d72442;
}

.btn-view {
	color: #fff;
	background-color: #0162e8;
	border-color: #0162e8;
}

.btn-view:hover {
	color: #fff;
	background-color: #003f97;
	border-color: #003f97;
}

.btn,
.sp-container button {
	border-width: 0;
	line-height: 1.538;
	padding: 9px 20px;
	transition: none;
}

.btn svg {
	fill: #fff;
}

.task-box.primary {
	color: #fff !important;
	background: #cf55b9;
	border-radius: 5px;
	font-family: "Saira", sans-serif !important;
	padding: 5px;
}

.task-box div {

	box-shadow: inherit !important;
}

.task-box p,
.task-box h3 {}

.task-box h3 {
	font-size: 22px;
}




/* button */

/* Add Form */

.add-form .bg-white {
	transform: translateX(0%);
	transition: 0.7s width cubic-bezier(0.23, 1, 0.32, 1);
	padding: 15px;
}

.add-form .form-group {
	margin: 10px 0px;
}

.add-form h6 {
	font-family: "Saira", sans-serif !important;
	font-size: 25px;
	font-weight: 600;
	color: #b32a7f;
}


.add-form input {
	font-family: "Saira", sans-serif !important;
	background: #fff !important;
	border: 1px solid #d2d2d2 !important;
	padding: 11px 10px !important;
	position: relative;
	display: block;
	width: 100%;
	color: #3c3c3c;
	border-radius: 3px;
	transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
	font-size: 13px;
}

.add-form textarea {
	font-family: "Saira", sans-serif !important;
	background: #fff;
	border: 1px solid #d2d2d2 !important;
	padding: 12px 10px !important;
	height: 100px;
	width: 100%;
}

.add-form label {
	font-family: "Saira", sans-serif !important;
	font-weight: 400 !important;
	font-size: 14px !important;
}

.add-form .MuiInputBase-root input {
	display: none;
}

.add-form .MuiSelect-select {
	font-family: "Saira", sans-serif !important;
	background: #fff !important;
	/*border: 1px solid #d2d2d2 !important;*/
	padding: 11px 10px !important;
	color: #3c3c3c;
}


.add-form .MuiButton-containedPrimary {
	font-family: "Saira", sans-serif !important;
	box-shadow: inherit !important;
	padding: 9px 32px;
	font-size: 16px;
	display: inline-block;
	width: auto;
	margin: 0 !important;
}


.close-button {
	position: absolute;
	top: 0;
	right: 0;
	border-radius: 0;
	padding: 16px;
}

.close-button svg {
	width: 18px
}


/* Add Form */


/* market place */

.market-palce-head {
	background: #fff;
	padding: 9px 11px 21px;
	border-radius: 11px;
}

.product-card {
	border-radius: 8px;
	margin-bottom: 0px;
	background: #fff;
	overflow: hidden;
	border: 1px solid #e8e8e8;
	transition: all linear .3s;
	-webkit-transition: all linear .3s;
	-moz-transition: all linear .3s;
	-ms-transition: all linear .3s;
	-o-transition: all linear .3s;
}

.product-media {
	position: relative;
}

.product-media::before {
	position: absolute;
	content: "";
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	background: linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgb(0, 0, 0, 0.5));
	opacity: 1;
	transition: all linear .3s;
	-webkit-transition: all linear .3s;
	-moz-transition: all linear .3s;
	-ms-transition: all linear .3s;
	-o-transition: all linear .3s;
	z-index: 9;
}

.product-img {
	overflow: hidden;
	height: 100%;
}

.product-card .product-img {
	overflow: hidden;
	height: 180px;
}

.product-img img {
	width: 100%;
	transition: all linear .5s;
}

.wishlist-icon {
	background: #fff !important;
	width: 23px !important;
	height: 30px;
	position: absolute !important;
	top: 10px;
	right: 10px;
	padding: 5px !important;
	border-radius: 50% !important;
	min-width: 30px !important;
	z-index: 99;
	border: 0 !important;
	text-align: center !important;
}


.product-media .wishlist-icon svg {
	width: inherit !important;
}


.product-media .badge {
	position: relative;
	z-index: 9;
}

.product-content {
	padding: 0px 15px 25px;
	position: relative;
	width: 100%;
}

.product-content h5 {
	font-size: 17px;
	color: #000;
	margin: 7px 0 10px;
	font-weight: 500;
}

.product-content p {
	font-size: 14px;
	font-weight: 300;
}

.product-content .price {
	font-size: 21px !important;
	font-weight: 600 !important;
	color: #000;
	margin: 10px 0px 0px 0px;
}

.product-content .date {
	font-family: "Outfit", sans-serif !important;
	font-size: 13px;
	color: #000;
	font-weight: 400;
	text-align: right;
	margin: 9px 0px 0px;
}

.product-content .price b {
	font-size: 21px !important;
	font-weight: 600 !important;
	color: #c942b1;
}

.product-content .text-truncate {
	font-family: "Outfit", sans-serif !important;
	font-size: 15px;
	color: #5b5b5b;
	font-weight: 400;
}

.product-card.standard {
	display: flex;
	align-items: center;
}

.product-card.standard .product-img img {
	width: 280px;
}

.product-card.standard .badge {
	font-family: "Saira", sans-serif !important;
	display: inline-block;
	padding: 7px 10px !important;
	font-size: 13px;
	font-weight: 700;
	line-height: 1;
	color: #fff;
	text-align: center;
	vertical-align: baseline;
	border-radius: .25rem;
	position: absolute;
	right: 0;
	bottom: 0;
}


.marketplace-place .serarch-bar input {
	background: #fff !important;
	height: 41px;
	border: 1px solid #d8dff0;
}

.filter-action {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.filter-action button {
	width: 40px;
	height: 40px;
	font-size: 15px;
	line-height: 40px;
	text-align: center;
	color: #000;
	background: #fff;
}

.filter-action button svg {
	fill: #000;
}

.filter-action button.MuiButton-contained {
	background: #cf55b9;
}

.filter-action button.MuiButton-contained svg {
	fill: #fff;
}

.product-card.standard .text-truncate {
	white-space: inherit !important;
}

.common-card {
	width: 100%;
	padding: 0;
	margin-bottom: 30px;
	border-radius: 8px;
	background: #fff;
}

.market-details h2 {
	font-family: "Saira", sans-serif;
	font-weight: 500;
	letter-spacing: 0;
	font-size: 24px;
	color: #000 !important;
	margin: 10px 0px 0px;
}

.market-details-box {
	border: 1px solid #ccc;
	padding: 25px
}

.market-details-left ul {
	list-style: none;
	padding: 0;
	line-height: 0;
	margin: 0 !important;
}

.market-details-left ul li {
	font-family: "Saira", sans-serif;
	display: inline-block;
	padding: 0px 15px;
	/*border-right: 1px solid #ccc;*/
	line-height: 0 !important;
	margin: 0;
	color: #828282;
	font-size: 14px;
	font-weight: 400;
}

.market-details-left ul li:first-child {
	padding-left: 0;
}

.market-details-left .space-y-4 {
	border: 1px solid #ccc;
	border-radius: 7px;
}

.market-details-left ul li svg {
	display: inline-block;
	line-height: 0;
	position: relative;
	top: -2px;
	margin-right: 4px;
}

.market-details-left ul li:last-child svg {
	fill: #828282;
}

.style2 {
	background-color: #2874F0;
	font-family: "Saira", sans-serif;
	color: #fff;
	font-size: 22px;
	font-weight: 500;
	border-radius: 7px;
	margin: 10px 0px 0px;
	width: 100%;
	display: inline-block;
	line-height: 78px;
	text-align: center;
	  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px transparent;
  transition-duration: 0.3s;
  transition-property: box-shadow, transform;
}
.style2:hover{
	box-shadow: 1px 10px 10px -10px rgba(0, 0, 24, 0.5);
  transform: scale(1.02);
}

.style2 .icon {
	display: inline-block;
	font-size: 24px;
	margin-right: 10px;
	vertical-align: top;
	float: left;
	width: 75px;
	background: rgba(0, 0, 0, 0.1);
	line-height: 80px;
	max-height: 80px;
	padding: 20px 17px;
	text-align: center;
}

.style2 .icon svg {
	width: 45px;
	fill: #fff;
}

.buy-order{
	background-color: #a3278d;
}

.market-details{
	font-family: "Saira", sans-serif;
}

.text-site-500{
	fill: #a3278d;
	color: #a3278d;
}

.market-details .space-y-2 li {
	line-height: 40px;
}

.right-price-op h2 {
	color: #fff !important;
	font-weight: 600;
	font-size: 32px;
}

.buy-n:hover{
	color: #a3278d !important;
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-icon-img{
	width: 80px;
}

.status-my-ads {
	position: absolute;
	top: 0;
	right: -2px;
	background: #ce55b9;
	z-index: 99;
	padding: 3px 15px;
	color: #fff;
	border-radius: 5px;
}

.product-content .date span{
	float: left;
}

.product-content .date span svg  {
	display: inline-block;
	color: #a2a2a2;
}

.filter label.custom-sort-label {
  line-height: 17px !important;
  
}

.filter label.MuiInputLabel-shrink{
background: #fff;
}

.add-form {
	z-index: 999;
}

.market-le h6{
	font-family: "Saira", sans-serif;
}

.disabled-row {
  background-color: #f2f2f2;
  opacity: 0.6;
  pointer-events: none;
}

.sitebg{
	background-color: #b057bf;
}

.pinned-active svg{
	width: 25px !important;
}

.breadcrumbs {
	padding: 5px 0px 0px;
}

.ads-grid b {
	color: #8c5050;
	font-weight: 500;
}

.ads-grid .MuiBox-root{
	font-weight: 500;
}

.ads-details-top span.MuiChip-label{
	color: #fFF  !important;
	font-weight: 500;
}

.ads-detals-s-2 span.MuiChip-label{
	color: #fFF  !important;
	font-weight: 500;
}

.css-eqpfi5-MuiAccordionSummary-content.Mui-expanded{
	margin: 0 !important;
}


header {
	position: fixed !important;
	z-index: 999 !important;
	height: 120px !important;
}

.mainpanel{
	margin-top: 130px !important;
}

/* market place */


.site-color{
	color: #a3278d !important;
}

.landing header{
	height: auto !important;
}


.bg-site{
	background: #a3278d !important;
}

footer img{
	width: 180px;
}

.dashboardblog  .MuiPaper-rounded{
	background: rgba(255, 255, 255, .6) !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAIA;CACC,+CAA+C;CAC/C,4CAA4C;CAC5C,0BAA0B;AAC3B;;AAEA;CACC,aAAa;AACd;;;AAGA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,oBAAoB;AACrB;;AAEA;CACC;EACC,4CAA4C;CAC7C;AACD;;AAEA;CACC,yBAAyB;CACzB,iBAAiB;CACjB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,6BAA6B;CAC7B,YAAY;AACb;;AAEA;CACC,cAAc;AACf;;AAEA;CACC;EACC,uBAAuB;CACxB;;CAEA;EACC,yBAAyB;CAC1B;AACD;;;AAGA;CACC,wCAAwC;CACxC,qBAAqB;CACrB,oBAAoB;CACpB,0BAA0B;CAC1B,8BAA8B;CAC9B,+BAA+B;AAChC;;AAEA;CACC,iCAAiC;CACjC,eAAe;CACf,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ;;;AAGA;CACC,kBAAkB;CAClB,6BAA6B;CAC7B,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,eAAe;CACf,oCAAoC;CACpC,mBAAmB;CACnB,uBAAuB;CACvB,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,4BAA4B;AAC7B;;;;AAIA;CACC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,WAAW;CACX,mBAAmB;CACnB,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,kCAAkC;CAClC,WAAW;CACX,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,WAAW;CACX,SAAS;CACT,UAAU;CACV,UAAU;CACV,oBAAoB;AACrB;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,iBAAiB;CACjB,8BAA8B;AAC/B;;AAEA,mBAAmB;;AAEnB;CACC,sBAAsB;CACtB,4CAA4C;CAC5C,eAAe;CACf,cAAc;AACf;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,8BAA8B;CAC9B,gBAAgB;CAChB,4CAA4C;CAC5C,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;CACtB,8BAA8B;;AAE/B;;;AAGA;CACC,yBAAyB;AAC1B;;AAEA;CACC,4CAA4C;CAC5C,eAAe;AAChB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE;;;;AAIF;CACC,8BAA8B;CAC9B,4CAA4C;CAC5C,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;;AAGA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,4CAA4C;CAC5C,sBAAsB;CACtB,eAAe;AAChB;;AAEA;CACC,8BAA8B;CAC9B,iCAAiC;CACjC,yBAAyB;CACzB,cAAc;CACd,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,4CAA4C;CAC5C,WAAW;CACX,gBAAgB;CAChB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,4CAA4C;CAC5C,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,sBAAsB;CACtB,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,oBAAoB;AACrB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,uBAAuB;AACxB;;;AAGA,QAAQ;;AAER;CACC,oCAAoC;AACrC;;AAEA;CACC,2BAA2B;CAC3B,2CAA2C;CAC3C,wBAAwB;CACxB,qBAAqB;CACrB,wBAAwB;CACxB,6CAA6C;AAC9C;;AAEA;CACC,8BAA8B;CAC9B,2CAA2C;CAC3C,wBAAwB;CACxB,yBAAyB;CACzB,wBAAwB;CACxB,6CAA6C;AAC9C;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;CACf,sBAAsB;CACtB,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,oBAAoB;CACpB,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kCAAkC;CAClC,8BAA8B;AAC/B;;AAEA;CACC,2CAA2C;CAC3C,eAAe;CACf,2BAA2B;CAC3B,uBAAuB;AACxB;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC,2CAA2C;CAC3C,eAAe;AAChB;;;AAGA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,yBAAyB;CACzB,kBAAkB;CAClB,WAAW;CACX,YAAY;AACb;;AAEA;CACC;;;;;;;;;sCASqC;AACtC;;AAEA;;CAEC;;EAEC,mBAAmB;EACnB,UAAU;CACX;;CAEA;;EAEC,qBAAqB;EACrB,UAAU;CACX;;CAEA;EACC,qBAAqB;EACrB,UAAU;CACX;AACD;;AAEA;CACC,2CAA2C;CAC3C,eAAe;CACf,2BAA2B;AAC5B;;AAEA;CACC,2CAA2C;CAC3C,eAAe;CACf,2BAA2B;AAC5B;;;;AAIA;CACC,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,YAAY;CACZ,qBAAqB;CACrB,2BAA2B;CAC3B,2BAA2B;CAC3B,6BAA6B;CAC7B,oBAAoB;CACpB,qBAAqB;CACrB,uCAAuC;CACvC,+CAA+C;AAChD;;;AAGA;CACC,cAAc;CACd,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;;;CAGC,2CAA2C;CAC3C,cAAc;CACd,gBAAgB;CAChB,yBAAyB;CACzB,cAAc;CACd,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA;;CAEC,mBAAmB;CACnB,2CAA2C;CAC3C,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,8BAA8B;CAC9B,gCAAgC;AACjC;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,sBAAsB;AACvB;;;AAGA;;CAEC,qBAAqB;CACrB,gBAAgB;CAChB,mBAAmB;CACnB,qDAAqD;AACtD;;AAEA;;CAEC,2CAA2C;CAC3C,cAAc;CACd,2BAA2B;CAC3B,eAAe;CACf,oBAAoB;CACpB,yBAAyB;CACzB,wBAAwB;CACxB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;;CAEC,WAAW;CACX,2BAA2B;AAC5B;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,2CAA2C;CAC3C,oCAAoC;CACpC,2BAA2B;CAC3B,2BAA2B;CAC3B,8BAA8B;AAC/B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,2CAA2C;CAC3C,YAAY;CACZ,mBAAmB;CACnB,mBAAmB;CACnB,yBAAyB;CACzB,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;CACd,sEAAsE;CACtE,0BAA0B;AAC3B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,2CAA2C;CAC3C,YAAY;CACZ,mBAAmB;CACnB,yBAAyB;CACzB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;CACd,sEAAsE;CACtE,0BAA0B;AAC3B;;AAEA;CACC,2CAA2C;CAC3C,eAAe;CACf,4BAA4B;AAC7B;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC,oCAAoC;CACpC,oCAAoC;CACpC,wBAAwB;CACxB,8BAA8B;CAC9B,2CAA2C;AAC5C;;AAEA;CACC,aAAa;CACb,WAAW;CAEX,iBAAiB;CACjB,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,UAAU;CACV,SAAS;AACV;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,WAAW;CACX,kBAAkB;AACnB;;AAEA;;CAEC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,sBAAsB;CACtB,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC,2CAA2C;CAC3C,eAAe;CACf,gBAAgB;CAChB,oBAAoB;CACpB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,2CAA2C;CAC3C,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,mBAAmB;CACnB,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,wBAAwB;CACxB,eAAe;AAChB;;;AAGA;CACC,2CAA2C;AAC5C;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,8BAA8B;CAC9B,2CAA2C;AAC5C;;AAEA;CACC,8BAA8B;CAC9B,8BAA8B;CAC9B,YAAY;CACZ,oBAAoB;AACrB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,8BAA8B;CAC9B,2BAA2B;CAC3B,2CAA2C;CAC3C,eAAe;CACf,gBAAgB;AACjB;;;AAGA;CACC,kBAAkB;CAClB,SAAS;CACT,eAAe;CACf,mBAAmB;CACnB,iBAAiB;CACjB,WAAW;CACX,gBAAgB;CAChB,eAAe;CACf,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,2CAA2C;CAC3C,eAAe;CACf,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,2CAA2C;CAC3C,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,2CAA2C;CAC3C,0BAA0B;CAC1B,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,6BAA6B;CAC7B,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,YAAY;CACZ,MAAM;CACN,OAAO;CACP,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CAKC,kBAAkB;CAClB,SAAS;CACT,WAAW;AALZ;;;AASA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,iBAAiB;AAClB;;;AAGA,WAAW;;;AAGX;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;CAEC,eAAe;CACf,kBAAkB;CAClB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,sBAAsB;CACtB,mBAAmB;CACnB,kBAAkB;CAClB,2CAA2C;CAC3C,YAAY;AACb;;AAEA;;CAEC,8BAA8B;AAC/B;;AAEA;cACc;;AAEd;CACC,eAAe;AAChB;;;;;AAKA,WAAW;;AAEX,aAAa;;AAEb;CAGC,yBAAyB;CAGzB,qDAAqD;CACrD,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2CAA2C;CAC3C,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;;AAGA;CACC,2CAA2C;CAC3C,2BAA2B;CAC3B,oCAAoC;CACpC,6BAA6B;CAC7B,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,cAAc;CACd,kBAAkB;CAClB,sEAAsE;CACtE,eAAe;AAChB;;AAEA;CACC,2CAA2C;CAC3C,gBAAgB;CAChB,oCAAoC;CACpC,6BAA6B;CAC7B,aAAa;CACb,WAAW;AACZ;;AAEA;CACC,2CAA2C;CAC3C,2BAA2B;CAC3B,0BAA0B;AAC3B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,2CAA2C;CAC3C,2BAA2B;CAC3B,wCAAwC;CACxC,6BAA6B;CAC7B,cAAc;AACf;;;AAGA;CACC,2CAA2C;CAC3C,8BAA8B;CAC9B,iBAAiB;CACjB,eAAe;CACf,qBAAqB;CACrB,WAAW;CACX,oBAAoB;AACrB;;;AAGA;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC;AACD;;;AAGA,aAAa;;;AAGb,iBAAiB;;AAEjB;CACC,gBAAgB;CAChB,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,yBAAyB;CACzB,0BAA0B;CAC1B,kCAAkC;CAClC,+BAA+B;CAC/B,8BAA8B;CAC9B,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,SAAS;CACT,WAAW;CACX,YAAY;CAEZ,6EAA6E;CAC7E,UAAU;CACV,0BAA0B;CAC1B,kCAAkC;CAClC,+BAA+B;CAC/B,8BAA8B;CAC9B,6BAA6B;CAC7B,UAAU;AACX;;AAEA;CACC,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,WAAW;CACX,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;CAC3B,sBAAsB;CACtB,YAAY;CACZ,6BAA6B;CAC7B,SAAS;CACT,WAAW;CACX,uBAAuB;CACvB,6BAA6B;CAC7B,0BAA0B;CAC1B,WAAW;CACX,oBAAoB;CACpB,6BAA6B;AAC9B;;;AAGA;CACC,yBAAyB;AAC1B;;;AAGA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,WAAW;CACX,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,WAAW;CACX,wBAAwB;AACzB;;AAEA;CACC,4CAA4C;CAC5C,eAAe;CACf,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,cAAc;AACf;;AAEA;CACC,4CAA4C;CAC5C,eAAe;CACf,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,2CAA2C;CAC3C,qBAAqB;CACrB,4BAA4B;CAC5B,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,WAAW;CACX,kBAAkB;CAClB,wBAAwB;CACxB,qBAAqB;CACrB,kBAAkB;CAClB,QAAQ;CACR,SAAS;AACV;;;AAGA;CACC,2BAA2B;CAC3B,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,WAAW;CACX,UAAU;CACV,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;CACf,sBAAsB;CACtB,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB;AACD;;AAEA;CACC,gBAAgB;CAChB,UAAU;CACV,cAAc;CACd,oBAAoB;AACrB;;AAEA;CACC,gCAAgC;CAChC,qBAAqB;CACrB,iBAAiB;CACjB,gCAAgC;CAChC,yBAAyB;CACzB,SAAS;CACT,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,cAAc;CACd,kBAAkB;CAClB,SAAS;CACT,iBAAiB;AAClB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,yBAAyB;CACzB,gCAAgC;CAChC,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,oBAAoB;CACpB,WAAW;CACX,qBAAqB;CACrB,iBAAiB;CACjB,kBAAkB;GAChB,yCAAyC;EAC1C,+BAA+B;EAC/B,yBAAyB;EACzB,0CAA0C;AAC5C;AACA;CACC,mDAAmD;EAClD,sBAAsB;AACxB;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,kBAAkB;CAClB,mBAAmB;CACnB,WAAW;CACX,WAAW;CACX,8BAA8B;CAC9B,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,UAAU;AACX;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,aAAa;CACb,cAAc;AACf;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,WAAW;CACX,mBAAmB;CACnB,WAAW;CACX,iBAAiB;CACjB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,cAAc;AACf;;AAEA;EACE,4BAA4B;;AAE9B;;AAEA;AACA,gBAAgB;AAChB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,gCAAgC;AACjC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;;AAGA;CACC,0BAA0B;CAC1B,uBAAuB;CACvB,wBAAwB;AACzB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA,iBAAiB;;;AAGjB;CACC,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;AACxB;;;AAGA;CACC,8BAA8B;AAC/B;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,8CAA8C;AAC/C","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Saira:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n\t/*font-family: \"Outfit\", sans-serif!important;*/\n\tfont-family: \"Roboto\", sans-serif !important;\n\tfont-size: 15px !important;\n}\n\n.mt-7 {\n\tmargin-top: 0;\n}\n\n\n.App {\n\ttext-align: center;\n}\n\n.App-logo {\n\theight: 40vmin;\n\tpointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n\t.App-logo {\n\t\tanimation: App-logo-spin infinite 20s linear;\n\t}\n}\n\n.App-header {\n\tbackground-color: #282c34;\n\tmin-height: 100vh;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: calc(10px + 2vmin);\n\tcolor: white;\n}\n\n.App-link {\n\tcolor: #61dafb;\n}\n\n@keyframes App-logo-spin {\n\tfrom {\n\t\ttransform: rotate(0deg);\n\t}\n\n\tto {\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n\n.mainmenu {\n\tborder-top: 1px solid #d5d8e2 !important;\n\tpadding: 0 !important;\n\tmargin: 0 !important;\n\theight: inherit !important;\n\tmin-height: inherit !important;\n\talign-items: inherit !important;\n}\n\n.mainmenu button {\n\tfont-family: \"Outfit\", sans-serif;\n\tfont-size: 15px;\n\tcolor: #000;\n\tborder-radius: 0;\n\tpadding-top: 10px;\n\tpadding-bottom: 10px;\n}\n\n.mainmenu button:hover {\n\tbackground-color: #b32a7f;\n\tcolor: #fff;\n\tborder-radius: 0;\n}\n\n.mainmenu button.active {\n\tbackground-color: #b32a7f;\n\tcolor: #fff;\n}\n\n\n.sub-nav .MuiTabs-flexContainer {\n\ttext-align: center;\n\tborder-bottom: 1px solid #ccc;\n\tjustify-content: center;\n}\n\n.schedule-one__single {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tflex-wrap: wrap;\n\tbackground-color: rgba(0, 0, 0, .08);\n\tborder-radius: 20px;\n\tpadding: 30px 40px 30px;\n\tmargin-bottom: 30px;\n\tz-index: 1;\n}\n\n.schedule-one__left {\n\tposition: relative;\n\tdisplay: block;\n}\n\n.top-brand {\n\tpadding: 16px 0px !important;\n}\n\n\n\n.schedule-one__img {\n\tposition: relative;\n\tdisplay: block;\n\tmax-width: 309px;\n\twidth: 100%;\n\tborder-radius: 20px;\n\toverflow: hidden;\n\tz-index: 1;\n}\n\n.schedule-one__img::after {\n\tbackground: hsla(0, 0%, 100%, 0.5);\n\tcontent: \"\";\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\theight: 0;\n\topacity: 1;\n\tz-index: 9;\n\tpointer-events: none;\n}\n\n.schedule-one__img img {\n\twidth: 100%;\n\tborder-radius: 20px;\n\tobject-fit: cover;\n\ttransition: all 1s ease-in-out;\n}\n\n.event-list table {}\n\n.event-list table th {\n\tbackground-color: #333;\n\tfont-family: \"Outfit\", sans-serif !important;\n\tfont-size: 14px;\n\tcolor: #ffffff;\n}\n\n.event-list table td img {\n\twidth: 35px;\n\theight: 35px;\n\tborder: 1px solid #ccc;\n\tpadding: 2px;\n}\n\n.event-list table {\n\tborder-radius: 10px !important;\n\toverflow: hidden;\n\tfont-family: \"Outfit\", sans-serif !important;\n\tbackground-color: #fff;\n}\n\n.event-list .MuiTableContainer-root {\n\tborder: 1px solid #ccc;\n\tborder-radius: 10px !important;\n\n}\n\n\n.event-list table tr:nth-child(2n) {\n\tbackground-color: #f8f6ff;\n}\n\n.event-list table td {\n\tfont-family: \"Outfit\", sans-serif !important;\n\tfont-size: 15px;\n}\n\n.event-list .active-btn svg:hover {\n\topacity: .5;\n}\n\n.filter-panel {\n\tmargin-bottom: 25px;\n}\n\n/*.serarch-bar .w-full {\n\tfont-family: \"Outfit\", sans-serif !important;\n\tbackground: #f9f9fb !important;\n\tborder: 1px solid #aeafc5 !important;\n\tpadding: 4px 5px 0px !important;\n\tposition: relative;\n\tfont-size: 16px;\n\tdisplay: block;\n\twidth: 100%;\n\tcolor: #495057;\n\tborder-radius: .25rem;\n\ttransition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n\theight: auto !important;\n}\n\n.serarch-bar svg {\n\twidth: 32px;\n\tbackground: #c942b1;\n\tfill: #fff;\n\tborder-radius: 6px;\n\theight: 32px;\n\tpadding: 5px;\n\tborder: 0;\n\tmargin-right: 10px;\n}*/\n\n\n\n.bg-primary {\n\tbackground: #b32a7f !important;\n\tfont-family: \"Outfit\", sans-serif !important;\n\tfont-size: 16px;\n\tcolor: #ffffff !important;\n}\n\n.bg-primary svg {\n\tcolor: #ffffff !important;\n}\n\n\n.event-data {\n\tbackground: #b32a7f;\n\tborder-radius: 10px;\n\ttext-align: center;\n\talign-content: center;\n\tpadding: 31px 31px;\n\tcolor: #fff !important;\n\theight: 100%;\n}\n\n.event-data p {\n\tfont-family: \"Outfit\", sans-serif !important;\n\tcolor: #fff !important;\n\tfont-size: 18px;\n}\n\n.upcoming-events-list .MuiPaper-elevation {\n\tbox-shadow: inherit !important;\n\tborder: 1px solid #ccc !important;\n\tbackground-color: #fdfbfb;\n\tmargin: 10px 0;\n\theight: auto !important;\n}\n\n.upcoming-events-list .MuiGrid-container {\n\tmargin-left: 0 !important;\n}\n\n.upcoming-events-list h6 {\n\tfont-family: \"Outfit\", sans-serif !important;\n\tcolor: #000;\n\tfont-weight: 500;\n\tfont-size: 18px;\n\tmargin-bottom: 5px;\n}\n\n.upcoming-events-list p {\n\tfont-family: \"Outfit\", sans-serif !important;\n\tcolor: #333;\n\tfont-weight: 400;\n\tline-height: 26px;\n\tfont-size: 16px;\n}\n\n.upcoming-events-list .row {\n\twidth: 100% !important;\n}\n\n.upcoming-events-list select {\n\tbackground: #fff;\n\tborder: 1px solid #ccc;\n\tpadding: 7px 12px;\n\tborder-radius: 5px;\n\tfont-size: 14px;\n\tmargin: 10px 0px 0px;\n}\n\n.text-primary {\n\tcolor: #b32a7f !important;\n}\n\n.text-primary:hover {\n\tcolor: #c942b1 !important;\n}\n\n.border-primary {\n\tborder-color: #b32a7f !important;\n}\n\n.upcoming-events-list .MuiInputBase-formControl {\n\twidth: 100% !important;\n}\n\n.upcoming-events-list .css-1nrlq1o-MuiFormControl-root {\n\twidth: 180px !important;\n}\n\n\n/* ----*/\n\nbody {\n\tbackground-color: #ecf0fa !important;\n}\n\n.header-sec {\n\tbackground: #fff !important;\n\tborder-bottom: 1px solid #d5d8e2 !important;\n\tborder-top: 0 !important;\n\tz-index: 1 !important;\n\tmargin-top: 0 !important;\n\tbox-shadow: 0 1px 15px 1px #c0c0c7 !important;\n}\n\n.header-new {\n\tbackground: #c942b1 !important;\n\tborder-bottom: 1px solid #d5d8e2 !important;\n\tborder-top: 0 !important;\n\t/*z-index: 1 !important;*/\n\tmargin-top: 0 !important;\n\tbox-shadow: 0 1px 15px 1px #c0c0c7 !important;\n}\n\n.header-nav {\n\tborder-bottom: 1px solid #d5d8e2 !important;\n}\n\n.nav-new {\n\tbackground-color: #fff !important;\n}\n\n.nav-new button {\n\tfont-family: \"Saira\", sans-serif;\n\tfont-weight: 500;\n\tletter-spacing: 0;\n\tfont-size: 16px;\n\tcolor: #000 !important;\n\tcursor: pointer;\n}\n\n.nav-new button span {\n\tcursor: pointer;\n}\n\n.header-nav .MuiButtonBase-root {\n\tbackground: #cf55b9;\n\tborder: 0 !important;\n\tpadding: 1px !important;\n\tmargin-right: 1px;\n}\n\n.header-nav .MuiButtonBase-root svg {\n\tfill: #fff !important;\n}\n\n.header-nav .MuiButtonBase-root:hover {\n\tbackground: transparent !important;\n\tbox-shadow: inherit !important;\n}\n\n.sub-menu {\n\tfont-family: \"Saira\", sans-serif !important;\n\tfont-size: 15px;\n\tfont-weight: 400 !important;\n\twidth: 250px !important;\n}\n\n.sub-menu a {\n\tfont-family: \"Saira\", sans-serif !important;\n}\n\n.profile-menu li {\n\tfont-family: \"Saira\", sans-serif !important;\n\tfont-size: 15px;\n}\n\n\n.pulse-wrapper {\n\tposition: relative;\n\tdisplay: inline-block;\n\tborder: 1px solid #aa3796;\n\tborder-radius: 50%;\n\twidth: 41px;\n\theight: 41px;\n}\n\n.pulse-dot {\n\t/*position: absolute;\n\ttop: 2px;\n\tright: -3px;\n\twidth: 15px;\n\theight: 15px;\n\tborder-radius: 50%;\n\tbackground: rgba(88, 11, 74, 0.6);\n\tbox-shadow: 0 0 0 rgba(53, 2, 44, 0.9);\n\tpointer-events: none;\n\tanimation: pulse 1s linear infinite;*/\n}\n\n@keyframes pulse {\n\n\t0%,\n\t8% {\n\t\ttransform: scale(0);\n\t\topacity: 0;\n\t}\n\n\t15%,\n\t30% {\n\t\ttransform: scale(0.5);\n\t\topacity: 1;\n\t}\n\n\t100% {\n\t\ttransform: scale(1.1);\n\t\topacity: 0;\n\t}\n}\n\n.breadcrumbs a {\n\tfont-family: \"Saira\", sans-serif !important;\n\tfont-size: 13px;\n\tfont-weight: 400 !important;\n}\n\n.breadcrumbs span {\n\tfont-family: \"Saira\", sans-serif !important;\n\tfont-size: 13px;\n\tfont-weight: 500 !important;\n}\n\n\n\n.card {\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\tmin-width: 0;\n\tword-wrap: break-word;\n\tbackground: #fff !important;\n\tbackground-clip: border-box;\n\tborder-radius: 6px !important;\n\tborder: 0 !important;\n\tmargin-bottom: 1.3rem;\n\tbox-shadow: 6px 11px 41px -28px #796eb1;\n\t-webkit-box-shadow: 6px 11px 41px -28px #796eb1;\n}\n\n\n.card-body {\n\tflex: 1 1 auto;\n\tpadding: 1.25rem;\n\twidth: 100%;\n}\n\n.top-sec {\n\twidth: 100%;\n}\n\n.main-content-label,\n.card-body h3,\n.card-body h4 {\n\tfont-family: \"Saira\", sans-serif !important;\n\tcolor: #302e40;\n\tfont-weight: 600;\n\ttext-transform: uppercase;\n\tline-height: 1;\n\tmargin-bottom: 10px;\n\tletter-spacing: .2px;\n}\n\n.top-sec button,\n.top-sec a {\n\tbox-shadow: inherit;\n\tfont-family: \"Saira\", sans-serif !important;\n\tfont-size: 14px;\n\tfont-weight: 500;\n}\n\n.top-sec button:hover {\n\tbox-shadow: inherit;\n}\n\n.site-bg {\n\tbackground: #cf55b9 !important;\n\tborder-color: #cf55b9 !important;\n}\n\n.site-bg:hover {\n\tbackground: #a3278d !important;\n}\n\n.text-white{\n\tcolor: #fff !important;\n}\n\n\n.table-bordered thead th,\n.table-bordered thead td {\n\tborder-top-width: 1px;\n\tpadding-top: 7px;\n\tpadding-bottom: 7px;\n\tbackground-color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.table thead th,\n.table thead td {\n\tfont-family: \"Saira\", sans-serif !important;\n\tcolor: #7987a1;\n\tfont-weight: 500 !important;\n\tfont-size: 14px;\n\tletter-spacing: .5px;\n\ttext-transform: uppercase;\n\tborder-bottom-width: 1px;\n\tborder-top-width: 0;\n\tpadding: 0 15px 5px;\n}\n\n.table thead th,\n.table thead th strong {\n\tcolor: #000;\n\tfont-weight: 500 !important;\n}\n\n.table thead th {\n\tpadding-top: 8px;\n\tpadding-bottom: 8px;\n}\n\n.table-striped tbody tr:nth-of-type(2n+1) {\n\tbackground-color: #f1f6fb !important;\n}\n\n.table-bordered td {\n\tfont-family: \"Saira\", sans-serif !important;\n\tborder: 1px solid #dedcfb !important;\n\tfont-weight: 400 !important;\n\tpadding-top: 5px !important;\n\tpadding-bottom: 5px !important;\n}\n\n.table-bordered td img {\n\twidth: 35px;\n\theight: 35px;\n\tborder-radius: 50%;\n}\n\n.serarch-bar .border {\n\tborder: 0 !important;\n}\n\n.serarch-bar {\n\tposition: relative;\n}\n\n.serarch-bar input {\n\tfont-family: \"Saira\", sans-serif !important;\n\theight: 37px;\n\tborder-radius: 35px;\n\tbackground: #ecf0fa;\n\tborder: 1px solid #ecf0fa;\n\tdisplay: block;\n\tfont-size: .875rem;\n\tfont-weight: 400;\n\tline-height: 1.5;\n\tcolor: #4d5875;\n\ttransition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\tpadding: 4px 60px 4px 20px;\n}\n\n.breadcrumbs svg {\n\twidth: 15px !important;\n}\n\n.serarch-bar svg {\n\tposition: absolute;\n\tright: 0;\n\twidth: 78px !important;\n}\n\n.filter {\n\tfont-family: \"Saira\", sans-serif !important;\n\theight: 40px;\n\tbackground: #ecf0fa;\n\tborder: 1px solid #ecf0fa;\n\tdisplay: block;\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tline-height: 1.5;\n\tcolor: #4d5875;\n\ttransition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\tpadding: 4px 60px 4px 20px;\n}\n\n.filter label {\n\tfont-family: \"Saira\", sans-serif !important;\n\tfont-size: 14px;\n\tline-height: 11px !important;\n}\n\n.MuiMenu-list li {\n\tfont-family: \"Saira\", sans-serif !important;\n}\n\n.upcoming-event-list {\n\tbackground-color: #F8F9FA !important;\n\tborder: 1px solid #F8F9FA !important;\n\tpadding: 1rem !important;\n\tmargin-bottom: 1rem !important;\n\tfont-family: \"Saira\", sans-serif !important;\n}\n\n.upcoming-event-list img {\n\theight: 180px;\n\twidth: 100%;\n\t-o-object-fit: cover;\n\tobject-fit: cover;\n\tborder-radius: 8px;\n\tborder: 1px solid #ccc;\n}\n\n.upcoming-event-list ul {\n\tlist-style: none;\n\tpadding: 0;\n\tmargin: 0;\n}\n\n.upcoming-event-list ul li {\n\tdisplay: inline-block;\n\tfont-weight: 500;\n\tcolor: #000;\n\tmargin-right: 15px;\n}\n\n.upcoming-event-list ul li:last-child {\n\n\tcolor: #a3278d;\n\tfont-weight: 500;\n}\n\n.upcoming-event-list ul li {\n\tmargin-bottom: 15px;\n}\n\n.upcoming-event-list ul li:last-child strong {\n\tfont-weight: 400;\n\tcolor: #000;\n}\n\n.upcoming-event-list svg {\n\twidth: 28px !important;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n}\n\n.upcoming-event-list h2 {\n\tfont-family: \"Saira\", sans-serif !important;\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tmargin: 20px 0px 5px;\n\tcolor: #000;\n}\n\n.upcoming-event-list {\n\tposition: relative;\n}\n\n.upcoming-event-list select {\n\tbackground: #aa3796;\n\tfont-family: \"Saira\", sans-serif !important;\n\tcolor: #fff;\n\tfont-size: 14px;\n\tpadding: 6px 17px;\n\tborder-radius: 35px;\n\tposition: absolute;\n\tright: 20px;\n\tbottom: 24px;\n\t-webkit-appearance: none;\n\tcursor: pointer;\n}\n\n\n.login-page {\n\tfont-family: \"Saira\", sans-serif !important;\n}\n\n.market-le .row {\n\twidth: 100%;\n}\n\n.product-card {\n\tborder-radius: 10px !important;\n\tfont-family: \"Saira\", sans-serif !important;\n}\n\n.product-card.card {\n\tbox-shadow: inherit !important;\n\tborder-radius: 11px !important;\n\theight: 100%;\n\tpadding-bottom: 50px;\n}\n\n.product-card.card .border-gray-200 {\n\tborder-color: transparent !important;\n}\n\n.product-card.card .\\!border {\n\tborder: 0 !important;\n}\n\n.product-card.card button {\n\tbox-shadow: inherit !important;\n\tborder-radius: 0 !important;\n\tfont-family: \"Saira\", sans-serif !important;\n\tfont-size: 14px;\n\tpadding: 8px 0px;\n}\n\n\n.ads-price {\n\tposition: absolute;\n\tbottom: 0;\n\tz-index: 989999;\n\tbackground: #ff61e3;\n\tpadding: 1px 14px;\n\tcolor: #fff;\n\tfont-weight: 500;\n\tfont-size: 17px;\n\tborder-radius: 0px 6px 4px 0px;\n}\n\n.mrl-lising {\n\tpadding-left: 25px;\n\tpadding-right: 25px;\n}\n\n.market-filter .MuiSelect-select {\n\tpadding-bottom: 0 !important;\n}\n\n.market-filter .filter label {\n\tline-height: 16px !important;\n}\n\n.product-card img {\n\tborder-radius: 10px 10px 0px 0px !important;\n}\n\n.product-content {\n\tpadding: 10px 15px;\n\tline-height: 30px;\n}\n\n.product-content span {\n\tcolor: #9939a9;\n}\n\n.product-content h2 {\n\tfont-family: \"Saira\", sans-serif !important;\n\tfont-size: 18px;\n\tcolor: #000;\n\tfont-weight: 500;\n}\n\n.product-content p {\n\tfont-family: \"Saira\", sans-serif !important;\n\tfont-size: 15px;\n\tfont-weight: 400;\n\tline-height: 26px;\n}\n\n.loading-msg {\n\tfont-family: \"Saira\", sans-serif !important;\n\tfont-size: 12px !important;\n\tfont-weight: 400;\n}\n\n.image-show {\n\tposition: relative;\n}\n\n.image-show::after {\n\tcontent: '';\n\tbackground: rgba(0, 0, 0, .3);\n\tdisplay: inline-block;\n\twidth: 100%;\n\theight: 100%;\n\tposition: absolute;\n\tz-index: 999;\n\ttop: 0;\n\tleft: 0;\n\tborder-radius: 10px;\n}\n\n.product-img {\n\tposition: relative;\n}\n\n.add-status {\n\tposition: absolute;\n}\n\n.add-status {\n\tposition: absolute;\n\ttop: 10px;\n\tright: 10px;\n}\n\n\n.ads-button {\n\tposition: absolute;\n\tbottom: 0;\n\twidth: 100%;\n}\n\n.ads-button .MuiBox-root {\n\tgap: 0 !important;\n}\n\n\n/* button */\n\n\n.btn-icon {\n\twidth: 30px;\n\theight: 30px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-shrink: 0;\n}\n\n.btn-indigo {\n\tcolor: #fff;\n\tbackground-color: #b057bf;\n\tborder-color: #b057bf;\n}\n\n.btn-indigo:hover {\n\tbackground-color: #9939a9;\n\tborder-color: #9939a9;\n}\n\n.btn-denger {\n\tcolor: #fff;\n\tbackground-color: #f53c5b;\n\tborder-color: #f53c5b;\n}\n\n.btn-denger:hover {\n\tcolor: #fff;\n\tbackground-color: #d72442;\n\tborder-color: #d72442;\n}\n\n.btn-view {\n\tcolor: #fff;\n\tbackground-color: #0162e8;\n\tborder-color: #0162e8;\n}\n\n.btn-view:hover {\n\tcolor: #fff;\n\tbackground-color: #003f97;\n\tborder-color: #003f97;\n}\n\n.btn,\n.sp-container button {\n\tborder-width: 0;\n\tline-height: 1.538;\n\tpadding: 9px 20px;\n\ttransition: none;\n}\n\n.btn svg {\n\tfill: #fff;\n}\n\n.task-box.primary {\n\tcolor: #fff !important;\n\tbackground: #cf55b9;\n\tborder-radius: 5px;\n\tfont-family: \"Saira\", sans-serif !important;\n\tpadding: 5px;\n}\n\n.task-box div {\n\n\tbox-shadow: inherit !important;\n}\n\n.task-box p,\n.task-box h3 {}\n\n.task-box h3 {\n\tfont-size: 22px;\n}\n\n\n\n\n/* button */\n\n/* Add Form */\n\n.add-form .bg-white {\n\t-webkit-transform: translateX(0%);\n\t-ms-transform: translateX(0%);\n\ttransform: translateX(0%);\n\t-webkit-transition: 0.7s width cubic-bezier(0.23, 1, 0.32, 1);\n\t-o-transition: 0.7s width cubic-bezier(0.23, 1, 0.32, 1);\n\ttransition: 0.7s width cubic-bezier(0.23, 1, 0.32, 1);\n\tpadding: 15px;\n}\n\n.add-form .form-group {\n\tmargin: 10px 0px;\n}\n\n.add-form h6 {\n\tfont-family: \"Saira\", sans-serif !important;\n\tfont-size: 25px;\n\tfont-weight: 600;\n\tcolor: #b32a7f;\n}\n\n\n.add-form input {\n\tfont-family: \"Saira\", sans-serif !important;\n\tbackground: #fff !important;\n\tborder: 1px solid #d2d2d2 !important;\n\tpadding: 11px 10px !important;\n\tposition: relative;\n\tdisplay: block;\n\twidth: 100%;\n\tcolor: #3c3c3c;\n\tborder-radius: 3px;\n\ttransition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\tfont-size: 13px;\n}\n\n.add-form textarea {\n\tfont-family: \"Saira\", sans-serif !important;\n\tbackground: #fff;\n\tborder: 1px solid #d2d2d2 !important;\n\tpadding: 12px 10px !important;\n\theight: 100px;\n\twidth: 100%;\n}\n\n.add-form label {\n\tfont-family: \"Saira\", sans-serif !important;\n\tfont-weight: 400 !important;\n\tfont-size: 14px !important;\n}\n\n.add-form .MuiInputBase-root input {\n\tdisplay: none;\n}\n\n.add-form .MuiSelect-select {\n\tfont-family: \"Saira\", sans-serif !important;\n\tbackground: #fff !important;\n\t/*border: 1px solid #d2d2d2 !important;*/\n\tpadding: 11px 10px !important;\n\tcolor: #3c3c3c;\n}\n\n\n.add-form .MuiButton-containedPrimary {\n\tfont-family: \"Saira\", sans-serif !important;\n\tbox-shadow: inherit !important;\n\tpadding: 9px 32px;\n\tfont-size: 16px;\n\tdisplay: inline-block;\n\twidth: auto;\n\tmargin: 0 !important;\n}\n\n\n.close-button {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tborder-radius: 0;\n\tpadding: 16px;\n}\n\n.close-button svg {\n\twidth: 18px\n}\n\n\n/* Add Form */\n\n\n/* market place */\n\n.market-palce-head {\n\tbackground: #fff;\n\tpadding: 9px 11px 21px;\n\tborder-radius: 11px;\n}\n\n.product-card {\n\tborder-radius: 8px;\n\tmargin-bottom: 0px;\n\tbackground: #fff;\n\toverflow: hidden;\n\tborder: 1px solid #e8e8e8;\n\ttransition: all linear .3s;\n\t-webkit-transition: all linear .3s;\n\t-moz-transition: all linear .3s;\n\t-ms-transition: all linear .3s;\n\t-o-transition: all linear .3s;\n}\n\n.product-media {\n\tposition: relative;\n}\n\n.product-media::before {\n\tposition: absolute;\n\tcontent: \"\";\n\ttop: 0px;\n\tleft: 0px;\n\twidth: 100%;\n\theight: 100%;\n\tz-index: 1;\n\tbackground: linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgb(0, 0, 0, 0.5));\n\topacity: 1;\n\ttransition: all linear .3s;\n\t-webkit-transition: all linear .3s;\n\t-moz-transition: all linear .3s;\n\t-ms-transition: all linear .3s;\n\t-o-transition: all linear .3s;\n\tz-index: 9;\n}\n\n.product-img {\n\toverflow: hidden;\n\theight: 100%;\n}\n\n.product-card .product-img {\n\toverflow: hidden;\n\theight: 180px;\n}\n\n.product-img img {\n\twidth: 100%;\n\ttransition: all linear .5s;\n}\n\n.wishlist-icon {\n\tbackground: #fff !important;\n\twidth: 23px !important;\n\theight: 30px;\n\tposition: absolute !important;\n\ttop: 10px;\n\tright: 10px;\n\tpadding: 5px !important;\n\tborder-radius: 50% !important;\n\tmin-width: 30px !important;\n\tz-index: 99;\n\tborder: 0 !important;\n\ttext-align: center !important;\n}\n\n\n.product-media .wishlist-icon svg {\n\twidth: inherit !important;\n}\n\n\n.product-media .badge {\n\tposition: relative;\n\tz-index: 9;\n}\n\n.product-content {\n\tpadding: 0px 15px 25px;\n\tposition: relative;\n\twidth: 100%;\n}\n\n.product-content h5 {\n\tfont-size: 17px;\n\tcolor: #000;\n\tmargin: 7px 0 10px;\n\tfont-weight: 500;\n}\n\n.product-content p {\n\tfont-size: 14px;\n\tfont-weight: 300;\n}\n\n.product-content .price {\n\tfont-size: 21px !important;\n\tfont-weight: 600 !important;\n\tcolor: #000;\n\tmargin: 10px 0px 0px 0px;\n}\n\n.product-content .date {\n\tfont-family: \"Outfit\", sans-serif !important;\n\tfont-size: 13px;\n\tcolor: #000;\n\tfont-weight: 400;\n\ttext-align: right;\n\tmargin: 9px 0px 0px;\n}\n\n.product-content .price b {\n\tfont-size: 21px !important;\n\tfont-weight: 600 !important;\n\tcolor: #c942b1;\n}\n\n.product-content .text-truncate {\n\tfont-family: \"Outfit\", sans-serif !important;\n\tfont-size: 15px;\n\tcolor: #5b5b5b;\n\tfont-weight: 400;\n}\n\n.product-card.standard {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.product-card.standard .product-img img {\n\twidth: 280px;\n}\n\n.product-card.standard .badge {\n\tfont-family: \"Saira\", sans-serif !important;\n\tdisplay: inline-block;\n\tpadding: 7px 10px !important;\n\tfont-size: 13px;\n\tfont-weight: 700;\n\tline-height: 1;\n\tcolor: #fff;\n\ttext-align: center;\n\tvertical-align: baseline;\n\tborder-radius: .25rem;\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n}\n\n\n.marketplace-place .serarch-bar input {\n\tbackground: #fff !important;\n\theight: 41px;\n\tborder: 1px solid #d8dff0;\n}\n\n.filter-action {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n}\n\n.filter-action button {\n\twidth: 40px;\n\theight: 40px;\n\tfont-size: 15px;\n\tline-height: 40px;\n\ttext-align: center;\n\tcolor: #000;\n\tbackground: #fff;\n}\n\n.filter-action button svg {\n\tfill: #000;\n}\n\n.filter-action button.MuiButton-contained {\n\tbackground: #cf55b9;\n}\n\n.filter-action button.MuiButton-contained svg {\n\tfill: #fff;\n}\n\n.product-card.standard .text-truncate {\n\twhite-space: inherit !important;\n}\n\n.common-card {\n\twidth: 100%;\n\tpadding: 0;\n\tmargin-bottom: 30px;\n\tborder-radius: 8px;\n\tbackground: #fff;\n}\n\n.market-details h2 {\n\tfont-family: \"Saira\", sans-serif;\n\tfont-weight: 500;\n\tletter-spacing: 0;\n\tfont-size: 24px;\n\tcolor: #000 !important;\n\tmargin: 10px 0px 0px;\n}\n\n.market-details-box {\n\tborder: 1px solid #ccc;\n\tpadding: 25px\n}\n\n.market-details-left ul {\n\tlist-style: none;\n\tpadding: 0;\n\tline-height: 0;\n\tmargin: 0 !important;\n}\n\n.market-details-left ul li {\n\tfont-family: \"Saira\", sans-serif;\n\tdisplay: inline-block;\n\tpadding: 0px 15px;\n\t/*border-right: 1px solid #ccc;*/\n\tline-height: 0 !important;\n\tmargin: 0;\n\tcolor: #828282;\n\tfont-size: 14px;\n\tfont-weight: 400;\n}\n\n.market-details-left ul li:first-child {\n\tpadding-left: 0;\n}\n\n.market-details-left .space-y-4 {\n\tborder: 1px solid #ccc;\n\tborder-radius: 7px;\n}\n\n.market-details-left ul li svg {\n\tdisplay: inline-block;\n\tline-height: 0;\n\tposition: relative;\n\ttop: -2px;\n\tmargin-right: 4px;\n}\n\n.market-details-left ul li:last-child svg {\n\tfill: #828282;\n}\n\n.style2 {\n\tbackground-color: #2874F0;\n\tfont-family: \"Saira\", sans-serif;\n\tcolor: #fff;\n\tfont-size: 22px;\n\tfont-weight: 500;\n\tborder-radius: 7px;\n\tmargin: 10px 0px 0px;\n\twidth: 100%;\n\tdisplay: inline-block;\n\tline-height: 78px;\n\ttext-align: center;\n\t  transform: perspective(1px) translateZ(0);\n  box-shadow: 0 0 1px transparent;\n  transition-duration: 0.3s;\n  transition-property: box-shadow, transform;\n}\n.style2:hover{\n\tbox-shadow: 1px 10px 10px -10px rgba(0, 0, 24, 0.5);\n  transform: scale(1.02);\n}\n\n.style2 .icon {\n\tdisplay: inline-block;\n\tfont-size: 24px;\n\tmargin-right: 10px;\n\tvertical-align: top;\n\tfloat: left;\n\twidth: 75px;\n\tbackground: rgba(0, 0, 0, 0.1);\n\tline-height: 80px;\n\tmax-height: 80px;\n\tpadding: 20px 17px;\n\ttext-align: center;\n}\n\n.style2 .icon svg {\n\twidth: 45px;\n\tfill: #fff;\n}\n\n.buy-order{\n\tbackground-color: #a3278d;\n}\n\n.market-details{\n\tfont-family: \"Saira\", sans-serif;\n}\n\n.text-site-500{\n\tfill: #a3278d;\n\tcolor: #a3278d;\n}\n\n.market-details .space-y-2 li {\n\tline-height: 40px;\n}\n\n.right-price-op h2 {\n\tcolor: #fff !important;\n\tfont-weight: 600;\n\tfont-size: 32px;\n}\n\n.buy-n:hover{\n\tcolor: #a3278d !important;\n}\n\n.loader-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n.loading-icon-img{\n\twidth: 80px;\n}\n\n.status-my-ads {\n\tposition: absolute;\n\ttop: 0;\n\tright: -2px;\n\tbackground: #ce55b9;\n\tz-index: 99;\n\tpadding: 3px 15px;\n\tcolor: #fff;\n\tborder-radius: 5px;\n}\n\n.product-content .date span{\n\tfloat: left;\n}\n\n.product-content .date span svg  {\n\tdisplay: inline-block;\n\tcolor: #a2a2a2;\n}\n\n.filter label.custom-sort-label {\n  line-height: 17px !important;\n  \n}\n\n.filter label.MuiInputLabel-shrink{\nbackground: #fff;\n}\n\n.add-form {\n\tz-index: 999;\n}\n\n.market-le h6{\n\tfont-family: \"Saira\", sans-serif;\n}\n\n.disabled-row {\n  background-color: #f2f2f2;\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.sitebg{\n\tbackground-color: #b057bf;\n}\n\n.pinned-active svg{\n\twidth: 25px !important;\n}\n\n.breadcrumbs {\n\tpadding: 5px 0px 0px;\n}\n\n.ads-grid b {\n\tcolor: #8c5050;\n\tfont-weight: 500;\n}\n\n.ads-grid .MuiBox-root{\n\tfont-weight: 500;\n}\n\n.ads-details-top span.MuiChip-label{\n\tcolor: #fFF  !important;\n\tfont-weight: 500;\n}\n\n.ads-detals-s-2 span.MuiChip-label{\n\tcolor: #fFF  !important;\n\tfont-weight: 500;\n}\n\n.css-eqpfi5-MuiAccordionSummary-content.Mui-expanded{\n\tmargin: 0 !important;\n}\n\n\nheader {\n\tposition: fixed !important;\n\tz-index: 999 !important;\n\theight: 120px !important;\n}\n\n.mainpanel{\n\tmargin-top: 130px !important;\n}\n\n/* market place */\n\n\n.site-color{\n\tcolor: #a3278d !important;\n}\n\n.landing header{\n\theight: auto !important;\n}\n\n\n.bg-site{\n\tbackground: #a3278d !important;\n}\n\nfooter img{\n\twidth: 180px;\n}\n\n.dashboardblog  .MuiPaper-rounded{\n\tbackground: rgba(255, 255, 255, .6) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
